<template>
	<div class="share-wrap flex flex-align-center">
		<span class="tip font-bold">内容分享</span>
		<span class="item bg-cover wechat-btn"></span>
		<qriously v-if="shareData.url" :value="shareData.url" :size="130" class="code"/>
		<span class="item bg-cover weibo-btn" @click="share('weibo')"></span>
		<span class="item bg-cover qq-btn" @click="share('qq')"></span>
		<span class="item bg-cover web-btn" @click="share('web')"></span>
		<span class="success-tip" :class="{active:webFlag}">链接复制成功</span>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueQriously from 'vue-qriously'
	Vue.use(VueQriously)
	import VueClipboard from 'vue-clipboard2'
	Vue.use(VueClipboard)
	export default {
		data() {
			return {
				webFlag:false
			}
		},
		props:['shareData'],
		methods: {
			share(type){
				let shareData = this.shareData;
				let title = shareData.title;
				let url = shareData.url;
				let image = shareData.image;
				let shareLink = '';
				if(type == 'weibo'){
					shareLink = 'https://service.weibo.com/share/share.php?title='+title+'&url='+url+'&pic='+image;
					window.open(shareLink);
				}else if(type == 'qq'){
					shareLink = 'https://connect.qq.com/widget/shareqq/index.html?url='+url+'&title='+title+'&pics='+image+'&site=%e6%8e%a2%e7%89%a9';
					window.open(shareLink);
				}else if(type == 'web'){
					this.$copyText(url).then(e => {
						this.webFlag = true;
						setTimeout(_ => {
							this.webFlag = false;
						},1000)
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.share-wrap{
		position: relative;
		font-size: 14px;
		margin: 36px auto 80px;
		.tip{
			margin-right: 20px;
		}
		.item{
			position: relative;
			box-sizing: border-box;
			width: 32px;
			height: 32px;
			border-radius: 50%;
			margin-right: 8px;
			cursor: pointer;
			background-size:50%; 
			box-shadow: 0 0 0 1px #000000 inset;
			overflow: hidden;
			transition: box-shadow 0.2s;
			&::after{
				content: '';
				position: absolute;
				opacity: 0;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				background-color: #3ED8C4;
				background-repeat:no-repeat;
				background-size:50%;
				background-position:center;    
				transition: opacity 0.2s;
			}
			&:hover{
				box-shadow: 0 0 0 1px #3ED8C4 inset;
				&::after{
					opacity: 1;
				}
			}
		}
		.wechat-btn{
			background-image: url(~@assets/img/share/wechat-black.png);
			&::after{
				background-image: url(~@assets/img/share/wechat-white.png);
			}
		}
		.weibo-btn{
			background-image: url(~@assets/img/share/weibo-black.png);
			&::after{
				background-image: url(~@assets/img/share/weibo-white.png);
			}
		}
		.qq-btn{
			background-image: url(~@assets/img/share/qq-black.png);
			&::after{
				background-image: url(~@assets/img/share/qq-white.png);
			}
		}
		.web-btn{
			background-image: url(~@assets/img/share/web-black.png);
			&::after{
				background-image: url(~@assets/img/share/web-white.png);
			}
		}
		.code{
			display: none;
			position: absolute;
			bottom: 45px;
			left: 27px;
			z-index: 10;
			border: 1px solid #000000;
			border-radius: 10px;
			background: #ffffff;
			canvas{
				display: block;
			}
		}
		.success-tip{
			display:none;
			position: absolute;
			bottom: 45px;
			left: 160px;
			padding: 5px 10px;
			border-radius: 4px;
			border:1px solid rgba($color: #000000, $alpha: 0.3);
			color: #666;
			background: #ffffff;
			&.active{
				display: block;
				animation: downAnim 0.3s;
			}
		}
		.wechat-btn:hover + .code{
			display: block;
			animation: downAnim 0.3s;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shareBox.vue